import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { RenewalDataFilter } from 'types/groupService';

export const GENERATE_FILES_FOR_AUTO_RENEW_FORM_ID = 'generate-files-for-auto-renew-form-id';

export const RENEWAL_DATA_FILTER_OPTIONS: OptionType[] = [
  { value: RenewalDataFilter.ALL, label: 'All' },
  { value: RenewalDataFilter.MISSING, label: 'Missing' },
  { value: RenewalDataFilter.MISMATCH, label: 'Mismatch' },
  { value: RenewalDataFilter.MATCHING, label: 'Matching' },
];
